import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface UpgradePromoBlockProps {
  pluginName: string;
  className?: string;
}

const UpgradePromoBlock: React.FC<UpgradePromoBlockProps> = ({ 
  pluginName, 
  className = '' 
}) => {
  const { t } = useTranslation();

  const getPluginDisplayName = () => {
    switch (pluginName) {
      case 'freshdesk':
        return 'Freshdesk';
      case 'mobile':
        return 'Mobile App';
      default:
        return pluginName;
    }
  };

  return (
    <div className={`upgrade-promo-block ${className}`}>
      <div className="upgrade-promo-content">
        <div className="upgrade-promo-text">
          <h3 className="upgrade-promo-title">
            {t('upgrade_promo_title', { plugin: getPluginDisplayName() })}
          </h3>
          <p className="upgrade-promo-description">
            {t('upgrade_promo_description', { plugin: getPluginDisplayName() })}
          </p>
        </div>
        <div className="upgrade-promo-action">
          <Link 
            to={`/licenses/buy?plugin=${pluginName}`}
            className="upgrade-promo-button"
          >
            {t('upgrade_promo_button')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default UpgradePromoBlock;
